export const getStatusStyles = (status) => {
  if (status?.toLowerCase() === "waiting for in-stock") {
    return { backgroundColor: "orange" };
  }
  switch (status?.toLowerCase()) {
    case "delivered":
      return { backgroundColor: "green" };
    case "cancel":
    case "return":
      return { backgroundColor: "red" };
    case "shipped":
    case "send to the enduser":
      return { backgroundColor: "blue" };
    default:
      return { backgroundColor: "yellow" };
  }
};

export const getDisplayStatus = (status) => {
  if (!status) return "";

  const lowerStatus = status.toLowerCase();

  // 1️⃣ Map backend-specific statuses to UI-friendly ones
  // if (lowerStatus.includes("send to") && lowerStatus.includes("end")) {
  //   return "Shipped";
  // }
  if (lowerStatus.includes("shipped")) {
    return "Shipped";
  }
  // 2️⃣ Protected statuses shown as-is
  const protectedStatuses = ["cancel", "return", "delivered"];

  if (protectedStatuses.includes(lowerStatus)) {
    return status;
  }

  // 3️⃣ Default fallback
  return "Order Placed";
};

export const numberFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
